import React from 'react'
import { observer } from 'mobx-react'
import styles from './BundlesEmptyState.sass'
import { EmptyState, EmptyStateIllustrationImage } from 'components/EmptyState'
import Workspace from 'iam/models/Workspace'
import { BundleArchivedFilterOptions } from 'admin/bundle/BundleRequestQueryFilterBuilder'

interface Props {
  currentWorkspace: Workspace
  currentArchivedStatusTab: BundleArchivedFilterOptions
}

export default observer(function BundlesEmptyState({
  currentWorkspace,
  currentArchivedStatusTab,
}: Props) {
  return (
    <div className={styles.emptyStateContainer}>
      {currentWorkspace === Workspace.none ? (
        <EmptyState
          className={styles.emptyState}
          image={
            <EmptyStateIllustrationImage
              src={require('assets/images/img_empty.svg')}
            />
          }
          title="No bundles to display"
          subtitle={
            <>
              There are currently no{' '}
              <span className={styles.boldText}>
                {mapBundleArchivedFilterOptionsToText(currentArchivedStatusTab)}
              </span>{' '}
              bundles.
            </>
          }
          animate
          small
        />
      ) : (
        <div className={styles.emptyStateContainer}>
          <EmptyState
            className={styles.emptyState}
            image={
              <EmptyStateIllustrationImage
                src={require('assets/images/img_empty.svg')}
              />
            }
            title="No bundles to display"
            subtitle={
              <>
                There are currently no{' '}
                <span className={styles.boldText}>
                  {mapBundleArchivedFilterOptionsToText(
                    currentArchivedStatusTab,
                  )}
                </span>{' '}
                bundles in the{' '}
                <span className={styles.boldText}>{currentWorkspace.name}</span>{' '}
                workspace.
              </>
            }
            animate
            small
          />
        </div>
      )}
    </div>
  )
})

function mapBundleArchivedFilterOptionsToText(
  currentArchivedStatusTab: BundleArchivedFilterOptions,
) {
  switch (currentArchivedStatusTab) {
    case BundleArchivedFilterOptions.ACTIVE:
      return 'active'
    case BundleArchivedFilterOptions.ARCHIVED:
      return 'archived'
  }
}
